/* 🤖 this file was generated by svg-to-ts */
export const iconZerionwallet: {
  name: 'zerionwallet';
  data: string;
} = {
  name: 'zerionwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0M6.94 8h16.54c.6 0 .94.64.6 1.1l-5.06 6.64c-.2.27-.58.33-.87.16L6.64 8.96c-.46-.28-.25-.96.3-.96m18.09 16H8.5c-.6 0-.95-.63-.61-1.09l5.07-6.64c.2-.27.57-.34.86-.17l11.52 6.94c.46.28.24.97-.31.97z"/></svg>`,
};
